import Vue from 'vue'
import Router from 'vue-router'
import { removeB,setFromHomePath,getFromHomePath} from '@/utils/cookies'
import {swapToken,getSwapToken} from '@/utils/value'

Vue.use(Router)


const Routers = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/components/home/home'),
      name: 'home',
      redirect: '/indexs',
      children:[
        { 
          path: '/headers',
          component: () => import('@/components/headers/headers')
        },{
          path: '/indexs',
          component: () => import('@/components/index/index'),
          name: 'indexs',
          meta: {title:'首页'}
        },
        {
          path: "/commodity-details",
          component: () =>
            import("@/components/pc/commodity-details/commodity-details"),
          name: "commodity-details",
          meta: {
            title: "商品详情",
            // requireAuth: true
          }
        },
        //search_key=&search_type=
        {
          path: "/commodity-list",
          component: () =>
            import("@/components/pc/commodity-list/commodity-list"),
            name: "commodityList",
            meta: { title: "商品列表" },
        },
        {
           path: '/ztroom',
           component: () => import('@/components/room/ztRoom'),
           name: 'ztroom'
         },
         {
           path: '/jproom',
           component: () => import('@/components/room/jpRoom'),
           name: 'jproom',
          meta: {title:'精品库'}
         },
      {
             path: '/rankingList',
             component: () => import('@/components/rankingList/rankingList'),
             name: 'rankingList',
            meta: {title:'榜单'}
           },
         {
             path: '/roomDetail',
             component: () => import('@/components/room/roomDetail'),
             name: 'roomDetail',
            meta: {title:'精品库详情'}
         },
         {
           path: '/mansion',
           component: () => import('@/components/mansion/mansion'),
           name: 'mansion',
            meta: {
              title:'本馆资源'
            }
         },
         {
           path: '/myRecommend',
           component: () => import('@/components/myRecommend/myRecommend'),
           name: 'myRecommend',
           meta: {title:'我的荐购'}
         },
        {
           path: '/aboutUs',
           component: () => import('@/components/aboutUS/aboutUs'),
           name: 'aboutUS',
           meta: {title:'关于我们'}
        }
      ]
    },
    {
      path: '/login',
      // component: () => import('@/components/login/login'),
      name: 'login',
      meta: {
        title: '欢迎登录',
        requireAuth: true
      }
    },
    {
      path: '/mobileLogin',
      // component: () => import('@/components/login/login'),
      name: 'mobileLogin',
      meta: {
        title: '欢迎登录',
        requireAuth: true
      }
    },

    {
      path: '/personalHome',
      // component: () => import('@/components/login/login'),
      name: 'personalHome',
      meta: {
        title: '个人中心',
        requireAuth: true
      }
    },
    {
      path: '/personalReadingNotes',
      // component: () => import('@/components/login/login'),
      name: 'personalReadingNotes',
      meta: {
        title: '我的阅读',
        requireAuth: true
      }
    },
    {
      path: '/personalcollect',
      // component: () => import('@/components/login/login'),
      name: 'personalcollect',
      meta: {
        title: '我的收藏',
        requireAuth: true
      }
    },
    {
      path: '/register',
      // component: () => import('@/components/register/register'),
      name: 'Register',
      meta: {
        title: '欢迎注册',
        requireAuth: true
      }
    },
    // 移动端页面路由
    {
      path: '/home',
      component: () => import('@/components/mobilePage/mHomePage/mHomePage'),
      name: 'home',
      children:[
        { 
          path: '/home',
          component: () => import('@/components/mobilePage/mHomePage/home/home'),
          meta: {
            title: '首页'
          }
        },
        { 
          path: '/classification',
          component: () => import('@/components/mobilePage/mHomePage/classification/classification'),
          meta: {
            title: '分类'
          }
        },
        { 
          path: '/libraryResources',
          component: () => import('@/components/mobilePage/mHomePage/libraryResources/libraryResources'),
          meta: {
            title: '本馆资源'
          }
        },
        { 
          path: '/libSearchPage',
          component: () => import('@/components/mobilePage/mHomePage/libraryResources/libSearchPage/libSearchPage'),
          meta: {
            title: '本馆资源'
          }
        },
      ]
    },
    {
      path: '/mReadList',
      component: () => import('@/components/mobilePage/mReadList/mReadList'),
      meta: {
        title: '阅读榜单'
      }
    },
    {
      path: '/bookSheSearch',
      component: () => import('@/components/mobilePage/mReadList/bookSheSearch'),
      meta: {
        title: '我的书架--搜索'
      }
    },
    {
      path: '/bookShe',
      component: () => import('@/components/mobilePage/mReadList/mMyFavourite'), 
      meta: {
        title: '我的书架'
      }
    },
    {
      path: '/mReadersRec',
      component: () => import('@/components/mobilePage/mReadList/mReadersRec'),
      meta: {
        title: '读者推荐'
      }
    },
    // { 
    //   path: '/accountSetting',
    //   component: () => import('@/components/mobilePage/mHomePage/mine/accountSetting'),
    //   meta: {
    //     title: '账号设置'
    //   }
    // },
    {
      path: '/alBought',
      component: () => import('@/components/mobilePage/alBought/alBought'),
      meta: {
        title: '已购资源'
      }
    },
    {
      path: '/msearch',
      component: () => import('@/components/mobilePage/alBought/mSearch'),
      meta: {
        title: '搜索页'
      }
    },
    // {
    //   path: '/msearchres',
    //   component: () => import('@/components/mobilePage/alBought/mSearchRes'),
    //   meta: {
    //     title: '搜索结果页'
    //   }
    // },
    {
      path: '/mresourcesList',
      component: () => import('@/components/mobilePage/resourcesList/resourcesList'),
      meta: {
        title: '配套资源'
      }
    },
    {
      path: '/mjpRoom',
      component: () => import('@/components/mobilePage/mjpRoom/mjpRoom'),
      meta: {
        title: '精品库'
      }
    },
    {
      path: '/mjpDetails',
      component: () => import('@/components/mobilePage/mjpDetails/mjpDetails'),
      meta: {
        title: '精品库详情'
      }
    },
    {
      path: '/mjpDetailsSearch',
      component: () => import('@/components/mobilePage/mjpSearch/mjpSearch'),
      meta: {
        title: '精品库搜索'
      }
    },
    {
      path: '/mjpSearchResult',
      component: () => import('@/components/mobilePage/mjpSearchResult/mjpSearchResult'),
      meta: {
        title: '精品库搜索结果'
      }
    },    {
      path: '/mproductdetail',
      component: () => import('@/components/mobilePage/mproductdetail/mproductdetail'),
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/searchPage',
      component: () => import('@/components/mobilePage/searchPage/searchPage'),
      meta: {
        title: '搜索'
      }
    },
    {
      path: '/searchResult',
      component: () => import('@/components/mobilePage/searchPage/components/searchResult/searchResult'),
      meta: {
        title: '搜索结果'
      }
    }
    
  ],
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {x:0,y:0}
  },
})

Routers.beforeEach((to, from, next) => {
 
  //debugger
   let fromPath = from.path
  //let thePath = to.fullPath  //非机构编码移除旧token 添加新token
  let thePath = to.path  //所有移除旧token 添加新token
   if(fromPath == '/' && (thePath == '/home' || thePath == '/indexs')){
    let url = window.location.href
    if(!url.includes('/home') && !url.includes('/indexs')){
       url = url + 'indexs'
     }
    let end = url.indexOf('&isLogin=true') > 0 ? url.indexOf('&isLogin=true') : url.length
    // debugger
    let urlPath = url.slice(url.indexOf('com/')+4,end)
      console.log(getFromHomePath())
      let homePath = getFromHomePath()
      // debugger
      //url中不含branchEncryptionCode 
      if(!to.query.branchEncryptionCode ){
        //cookie中不含branchEncryptionCode
        if(!homePath){
          swapToken(false)
        }else if(homePath.indexOf('branchEncryptionCode') < 0){
          swapToken(false)
        }
      }
      setFromHomePath(urlPath)
      if(to.query.isLogin){
        delete to.query.isLogin
        var toPathQuery = to.path+'?'+Object.entries(to.query).map(([key, val]) => `${key}=${val}`).join('&')
        swapToken(false)
        next(toPathQuery)
      }else{
        next()
      }
   }else{
    next();
   }
   
 });
export default Routers


// WEBPACK FOOTER //
// ./src/router/index.js